const breadCrumb = "Lotação de Servidores - Carga Horária";

const routes = [
  {
    path: "/manutencao-horario-aula",
    name: "manutencao-horario-aula",
    meta: {
      allowedPermissions: ["horario_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CargaHoraria/ManutencaoHorarioAula/ManutencaoHorarioAulaHome.vue"
      ),
  },
  {
    path: "/manutencao-horario-aula/novo",
    name: "manutencao-horario-aula-novo",
    meta: {
      allowedPermissions: ["horario_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CargaHoraria/ManutencaoHorarioAula/ManutencaoHorarioAulaCad.vue"
      ),
  },
  {
    path: "/manutencao-horario-aula/editar/:id",
    name: "manutencao-horario-aula-editar",
    meta: {
      allowedPermissions: ["horario_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CargaHoraria/ManutencaoHorarioAula/ManutencaoHorarioAulaEdit.vue"
      ),
  },
];

export default routes;
